import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { browserHistory, Link } from 'react-router';
import { Grid, Paper } from '@material-ui/core';
import { claimListHd, claimFilterOps } from '../'
import { TableListComp, ExportManu, EmptyCollection, FilterComponent, PageLoader } from '../../../shared_elements';
import { STableLoader } from '../../../shared_elements/loaders';
import { exportClaimApi, getClaimsListApi } from '../apiServices';
import { ClaimRow } from '../components';
import { ContractSideBar, Header } from '../../../applications/contracts/Elements';
import { sExportContractsAc } from '../../actionCreators';
import { assetsType } from '../../../constants';
import { getLocalStorageInfo } from '../../../utils_v2';
import restrictIcon from '../../../shared/assets/img/restrict_icon.svg';
import ClaimFilter from '../components/ClaimFilter';

class ClaimListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skeletonLoader: true,
      pageLoader: false,
      claims: {
        list: [],
        pagination: {}
      },
      isOpen: false,
      sort: '',
      sort_by: '',
      filter: {},
      applyingFilter: {},
      filterOption: {},
    };
    this.getClaimsListApi = getClaimsListApi.bind(this);
    this.exportClaimApi = exportClaimApi.bind(this);
  }
  componentDidMount() {
    setTimeout(() => {
      this.getClaimsListApi(this.props, {per_page: 20}, 'skeletonLoader');
    }, 4000);
  }

  createSortHandler = (sortField) => {
    const { sort, sort_by, filter } = this.state;
    this.setState({
      sort: sortField,
      sort_by: (sortField === sort ? sort_by === 'asc' ? 'desc' : 'asc' : 'asc')
    });
    if (sortField === sort) {
      if (sort_by === 'asc') {
        this.getClaimsListApi(this.props, { ...filter, sort: sortField, sort_by: 'desc', per_page: 20 }, 'pageLoader');
      } else {
        this.getClaimsListApi(this.props, { ...filter, sort: sortField, sort_by: 'asc', per_page: 20 }, 'pageLoader');
      }
    } else {
      this.getClaimsListApi(this.props, { ...filter, sort: sortField, sort_by: 'asc', per_page: 20 }, 'pageLoader');
    }
  }

  changeMsn = (evt) => {
    let url = '/' + assetsType[evt.asset_type] + '/' + evt.slug + '/contracts/';
    browserHistory.push(url);
    this.props.params.type = assetsType[evt.asset_type];
    this.props.params.aircraft_slug = evt.slug;
  }
  render() {
    const { skeletonLoader, filter, claims, sort, sort_by, pageLoader } = this.state;
    let filterOptions = Object.assign({}, claimFilterOps);
    return (
      <section className="lease-management-section">
        <div className="mr-rate-wrapper  mr-rate-spacing">
          <Header type="short" headingText="Lease Management" params={this.props.params} changeMsn={this.changeMsn} exportContract={this.props.exportContract} />
          <ContractSideBar application={`Claims`} type="shorter" params={this.props.params} />
          {!getLocalStorageInfo()?.defaultLessor?.is_maintenance_enable ? <div>
          <Grid xs="12" style={{ minHeight: '90vh', position: 'relative' }}>
            <div className="page-not-found">
              <img src={restrictIcon} alt="Icon" />
              <h2>You’re not permitted to see this.</h2>
              <p>The page you’re trying to access has restricted access,<br />
                please contact <a style={{ color: '#3F51B5', textDecoration: 'auto' }} href="mailto:support@sparta.aero">support@sparta.aero</a> to access this application.
              </p>
              <Link className="start-over btn btn-default return-home" onClick={() => window.location.assign("https://sparta.aero")}>Return Home</Link>
            </div>
          </Grid>
        </div> : <div className="view-block" style={{ background: 'none' }}>
            <div>
              {skeletonLoader ? (<STableLoader count={4} />) :
                (
                  <Fragment>
                    <Paper square style={{ padding: '6px 10px' }}>
                      <Grid container spacing={1} alignItems='center'>
                        <Grid item md={11}>
                          <ClaimFilter
                            filter={filter}
                            filterMenu={filterOptions}
                            getResponseBack={(applyFilter) => { this.getClaimsListApi(this.props, { ...applyFilter, page: 1, per_page: claims.pagination.per_page }, 'pageLoader') }}
                          />
                        </Grid>
                        {claims?.list?.length > 0
                          // && checkPermission('contracts', 'claims','EXP') 
                          &&
                          <Grid item md={1}>
                            <ul className="list-inline" style={{ float: 'right', display: 'flex' }}>
                              <li className="list-inline-item">
                                <ExportManu title="Export" files={[{ title: 'Excel', extension: 'xlsx', key: '' }]} exportReportFn={(file) => this.exportClaimApi(this.props, { ...filter, download: file.extension })} />
                              </li>
                            </ul>
                          </Grid>}
                      </Grid>
                    </Paper>
                    <TableListComp
                      maxheight={(window.innerHeight - 265) + 'px'}
                      height = {(window.innerHeight - 265) + 'px'}
                      heads={claimListHd}
                      bulkOperation={false}
                      sort_by={sort_by}
                      sort={sort}
                      data={claims?.list?.map((item, index) =>
                        <ClaimRow
                          params={this.props.params}
                          index={index}
                          item={item} />
                      )
                      }
                      createSortHandler={this.createSortHandler}
                      onChangePage={(event, newPage) => { this.getClaimsListApi(this.props, { ...filter, page: newPage + 1, per_page: claims.pagination.per_page, sort: sort, sort_by: sort_by }, 'pageLoader') }}
                      onChangeRowsPerPage={(event) => { this.getClaimsListApi(this.props, { ...filter, page: 1, per_page: event.target.value, sort: sort, sort_by: sort_by }, 'pageLoader') }}
                      pagination={claims?.pagination}
                      noRecord={claims?.list?.length ? null :
                        <EmptyCollection
                          title="No records found"
                        />
                      }
                    />
                  </Fragment>

                )
              }
              {pageLoader ? <PageLoader /> : null}
            </div>
          </div>}
          
        </div>
      </section>
    )
  }
}
const mapStateToProps = state => ({
  invoiceExportLoader: state.InvoiceReducer.invoiceExportLoader
});
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    exportContract: (contract_slug) => dispatch(sExportContractsAc(contract_slug))
  }
}
export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(ClaimListing));
